import { API_RESPONSE } from 'eva-fe-sdk-types';
import { GameQuery } from '../types/GameQuery';
import { SDKRequestInit } from '../lib/ApiFetch';
import CrudConsumer from './index';
import Endpoint from '../lib/Endpoint';

interface GameRequestInit extends RequestInit {
  query?: GameQuery;
}

class Games extends CrudConsumer {
  getAll = (config: SDKRequestInit) => {
    const url: string = Endpoint.getGames(this.productType);
    return this.apiFetch.get<API_RESPONSE.Games['200']>(url, config);
  };

  getInfo = (gameId: string, config: GameRequestInit) => {
    const url: string = Endpoint.getGameInfo(this.productType, gameId);
    return this.apiFetch.get<API_RESPONSE.GameInfo['200']>(url, config);
  };

  getReal = (gameId: string, config: GameRequestInit) => {
    const url: string = Endpoint.getRealGame(this.productType, gameId);
    return this.apiFetch.get<API_RESPONSE.GameReal['200']>(url, config);
  };

  getDemo = (gameId: string, config: GameRequestInit) => {
    const url: string = Endpoint.getDemoGame(this.productType, gameId);
    return this.apiFetch.get<API_RESPONSE.GameDemo['200']>(url, config);
  };

  getRandom = (config: GameRequestInit) => {
    const url: string = Endpoint.getRandomGame(this.productType);
    return this.apiFetch.get<API_RESPONSE.GameRandom['200']>(url, config);
  };

  getFavourites = (config: SDKRequestInit) => {
    const url: string = Endpoint.getFavourites(this.productType);
    return this.apiFetch.get<API_RESPONSE.Favourites['200']>(url, config);
  };

  getFavouritesCommon = (config: SDKRequestInit) => {
    const url = Endpoint.getFavouritesCommon();
    return this.apiFetch.get<API_RESPONSE.FavouritesCommon['200']>(url, config);
  };

  getGamesByIds = (lobbyIds: Array<string>, config: SDKRequestInit) => {
    const url = Endpoint.getGamesByIds(this.productType);

    let body;

    if (config?.body) {
      body = config.body;
    } else {
      body = lobbyIds?.length ? { lobbyIds } : undefined;
    }

    return this.apiFetch.post<API_RESPONSE.GamesByIds['200']>(url, {
      ...config,
      body,
    });
  };

  addFavourite = (gameId: string, config: GameRequestInit) => {
    const url: string = Endpoint.getToggleFavouriteGame(
      this.productType,
      gameId
    );
    return this.apiFetch.post<API_RESPONSE.AddFavouriteGame['200']>(
      url,
      config
    );
  };

  removeFavourite = (gameId: string, config: GameRequestInit) => {
    const url: string = Endpoint.getToggleFavouriteGame(
      this.productType,
      gameId
    );
    return this.apiFetch.delete<API_RESPONSE.RemoveFavouriteGame['200']>(
      url,
      config
    );
  };

  getRecents = (config: GameRequestInit) => {
    const url: string = Endpoint.getRecents(this.productType);
    return this.apiFetch.get<API_RESPONSE.RecentGames['200']>(url, config);
  };

  addRecents = (ids: Array<string>, config: SDKRequestInit) => {
    const url: string = Endpoint.addRecents(this.productType);
    let body;

    if (config?.body) {
      body = config.body;
    } else {
      body = ids?.length ? { ids } : undefined;
    }

    return this.apiFetch.put<API_RESPONSE.AddRecentGames['200']>(url, {
      ...config,
      body,
    });
  };
}

export default Games;
